<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:23:52
-->
<template>
    <div  id="box" class="box">
        <div id="left" class="left">
            <div style="font-weight: 600;" class="title">微博账号</div>
            <div class="search">
                <a-input-search
                    v-model="name"
                    placeholder="搜索微博号"
                    size="large"
                    @search="search"
                >
                    <template #enterButton>
                        <img class="img" src="@/assets/images/search.jpg" @click="search"/>
                    </template>
                </a-input-search>
            </div>
            <div @click="closeAll">
                <img class="close-img" src="@/assets/images/close.jpg" /><span
                    class="close-name"
                    >全部收缩</span
                >
            </div>
            <a-tree
                ref="tree"
                show-line
                :tree-data="treeData"
                @select="onSelect"
                :autoExpandParent="isCloseAll"
                :selectedKeys="checkedKeys"
            >
            </a-tree>
        </div>
        <div id="resize"></div>
        <div id="right" class="right">
            <div class="right-name">微博稿件-{{weBoName}}</div>
            <div class="search">
                <a-select
                    v-model="type"
                    style="width: 500px; margin-right: 20px"
                    placeholder="按所属组织筛选"
                    size="large"
                >
                    <a-select-option value="0">全部</a-select-option>
                    <a-select-option value="1">近一周</a-select-option>
                    <a-select-option value="2">近一月</a-select-option>
                    <a-select-option value="3">近三月</a-select-option>
                </a-select>
                <a-input
                    style="width: 170px; margin-right: 20px"
                    v-model="content"
                    placeholder="按标题搜索"
                    size="large"
                />
                <el-button type="primary"  @click="listSearch"
                ></span>查询</el-button
                >
            </div>
             <a-spin :spinning="loading">
            <coententTable
                :y="height"
                @handleTableChange="handleTableChange"
                @onShowSizeChange="onShowSizeChange"
                :columns="columns"
                :dataSource="dataSource"
            >
            </coententTable>
             </a-spin>
            <div id="pagination" class="pagination">
                <a-pagination
                    :current="pagination.current"
                    :pageSize="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :total="pagination.total"
                    @change="onShowSizeChange"
                    @showSizeChange="handleTableChange"
                    :page-size-options="pagination.pageSizeOptions"
                    :show-total="(total) => `共 ${pagination.total} 条`"
                />
            </div>
        </div>
    </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { wbCountPage, selectListTree } from "./index.js";

export default {
    data() {
        return {
            value: "",
            height: 0,
            isCloseAll: false,
            expandedKeys: [],
            selectedKeys: [],
            treeData: [],
            checkedKeys:[],
            weBoId: "",
            weBoName:'',
            role: undefined,
            type: "0",
            name: "",
            content: "",
            columns: [
                {
                    title: "标题",
                    dataIndex: "title",
                    ellipsis: true,
                    customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
                },
                {
                    title: "发布时间",
                    dataIndex: "time",
                    width:200,
                    ellipsis: true,
                },
                {
                    title: "阅读数",
                    dataIndex: "readNumber",
                    width:120,
                    ellipsis: true,
                },
                {
                    title: "点赞数",
                    dataIndex: "likes",
                     width:120,
                    ellipsis: true,
                },
                {
                    title: "留言数",
                    dataIndex: "commentNumber",
                     width:120,
                    ellipsis: true,
                },
                {
                    title: "转发数",
                    dataIndex: "forwards",
                     width:120,
                    ellipsis: true,
                },
            ],
            pagination: {
                current: 1,
                pageSize: 15,
                total: 0,
                pageSizeOptions: ["15", "25", "35"],
            },
            dataSource: [],
            loading: false,
        };
    },
    components: {
        coententTable,
    },
    mounted() {
       
        this.getListTree();
        this.getList();
        this.getLeftMove();
    },
    methods: {
        listSearch(){
            this.pagination.current = 1;
            this.getList();
        },
        getLeftMove(){
            var resize = document.getElementById("resize");
            var left = document.getElementById("left");
            var right = document.getElementById("right");
            var box = document.getElementById("box");
            var pagination = document.getElementById("pagination");
            resize.onmousedown = function(e){
                var startX = e.clientX;
                resize.left = resize.offsetLeft;
                document.onmousemove = function(e){
                var endX = e.clientX;

                var moveLen = resize.left + (endX - startX);
                var maxT = box.clientWidth - resize.offsetWidth;
                if(moveLen<250) moveLen = 250;
                if(moveLen>600) moveLen = 600;  
                if(moveLen>maxT-150) moveLen = maxT-150;

                resize.style.left = moveLen;
                left.style.width = moveLen + "px";
                right.style.width = (box.clientWidth - moveLen - 5) + "px";
                pagination.style.width = (box.clientWidth - moveLen + 5) + "px";

                }
                document.onmouseup = function(evt){
                document.onmousemove = null;
                document.onmouseup = null; 
                resize.releaseCapture && resize.releaseCapture();
                }
                resize.setCapture && resize.setCapture();
                return false;
            }
        },
        closeAll() {
            this.isCloseAll = false;
            this.$nextTick(() => {
                this.isCloseAll = true;
            });
        },
        onSelect(key, event) {
            this.weBoId = key[0];
            if(key.length == 0){
                return;
            }
            if(this.weBoId == 'xx' || this.weBoId == 'xxx'){
                    this.dataSource = [];
                    this.pagination.current = 1;
                    this.pagination.pageSize = 10;
                    this.pagination.total = 0;
            }
            this.weBoName = event.node._props.title;
            this.pagination.current = 1;
            if(this.weBoId != 'xx' && this.weBoId != 'xxx'){
                this.getList();
            }
             this.checkedKeys = [this.weBoId]
        },
        search() {
            this.getListTree();
        },
        // 切换 搜索
        selectFn(value) {
            this.selectValue = value;
        },
        onShowSizeChange(current) {
            this.pagination.current = current;
            this.getList();
        },
        handleTableChange(page,pageSize) {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getList();
        },
        getList() {
            const _this = this;
            this.loading = true;
            let reqData = {
                id: _this.weBoId,
                type: _this.type,
                content: _this.content,
                channelType: 2,
                size: _this.pagination.pageSize,
                current: _this.pagination.current,
            };
            wbCountPage(reqData).then((res) => {
                if (res.code == 0) {
                    _this.dataSource = res.data.records;
                    _this.pagination.current = res.data.current;
                    _this.pagination.pageSize = res.data.size;
                    _this.pagination.total = res.data.total;
                    if(_this.pagination.total > 0){
                         this.height = document.documentElement.clientHeight - 400;
                        window.onresize = () => {
                            return (() => {
                                this.height = document.documentElement.clientHeight - 400;
                                var left = document.getElementById("left");
                                var box = document.getElementById("box");
                                var right = document.getElementById("right");
                                var pagination = document.getElementById("pagination");
                                this.height = document.documentElement.clientHeight - 400;
                                left.style.width = 250 + "px";
                                right.style.width = (box.clientWidth - 250 - 5) + "px";
                                pagination.style.width = (box.clientWidth - 250 + 5) + "px";
                            })();
                        };
                    }
                    if (
                        _this.pagination.current != 1 &&
                        _this.dataSource.length == 0
                    ) {
                        _this.pagination.current--;
                        _this.getList();
                    }
                    _this.loading = false;
                }
                 this.loading = false;
            });
        },
        getListTree() {
            const _this = this;
            let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            let reqData = {
                siteId: sessionStorage.getItem("siteId"),
                userId: userInfo.id,
                name: _this.name,
            };
            selectListTree(reqData).then((res) => {
                if (res.code == 0) {
                    if(res.data.length>0){
                        _this.weBoId = res.data.isData[0].id;
                    }
                    let options = [
                        {
                            title: "我授权的微博",
                            id: 'xx',
                            children: [],
                        },
                        {
                            title: "其他人授权的微博",
                            id: 'xxx',
                            children: [],
                        },
                    ]
                    _this.getList();
                    options[0].children = res.data.isData
                    options[1].children = res.data.other
                    options = JSON.stringify(options)
                        .replace(/screenName/g, "title")
                        .replace(/id/g, "key");
                    _this.treeData = JSON.parse(options);
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.box {
    display: flex;
    height: 100%;
    width: 100%;
    max-height: calc(94% - 10px);
    //position: relative;
    .left {
        width: 250px;
        border-right: solid 1px #E4E7ED;
        height: calc(107.5% - 3px);
        font-size: 14px;
        color: #000;
        padding: 24px;
        .title {
            margin-bottom: 24px;
        }
        .search {
            margin-bottom: 12px;
        }
        /deep/ .ant-btn-primary {
            background: #1890ff;
            padding: 0 5px;
        }
        /deep/ input::-webkit-input-placeholder {
            color: #415058;
        }
        /deep/ .ant-input {
            background: #f7f7f7;
        }
    }
    .right {
        flex: 1;
        height: 100%;
        width: 100%;
        font-size: 14px;
        color: #000;
        padding-top: 24px;
        width: 500px;
        .right-name {
            padding-left: 24px;
            font-weight: 600;
        }
        .search {
            display: flex;
            width: 480px;
            margin-left: 24px;
            margin-top: 24px;
            /deep/ .ant-select-selection {
               background-color: rgba(245, 247, 250, 1);
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                 color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
        }

        /deep/ .ant-table-wrapper {
            //width: 100%;
        }
        
    }
}
/deep/ .ant-tree {
    max-height: 630px;
    overflow: hidden;
    overflow-y: auto;
}
.close-name {
    color: #303133;
    font-weight: 400;
    margin-top: 4px;
}
.close-img {
    margin-top: -1px;
    margin-right: 4px;
    cursor: pointer;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #E4E7ED 1px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 245px);
  padding-right: 24px;
  bottom: 0px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
/deep/ .ant-spin-nested-loading{
    width: 100%;
}
.el-button--primary {
  background: #176de6;
}
#resize{
  width:5px;
  height:100%;
  cursor: w-resize;
  float:left;
}
</style>